// here you find constants used only in front end code
// for back end only constants look in services/constants.js
// for shared constants look in lib/constants.js

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const APP_LOGOUT = 'APP_LOGOUT';
export const GET_COURSE_REQUEST = 'GET_COURSE_REQUEST';
export const GET_COURSE_SUCCESS = 'GET_COURSE_SUCCESS';
export const GET_COURSE_FAILURE = 'GET_COURSE_FAILURE';
export const GET_USER = 'GET_USER';

// Dashboards actions
export const NULL_STATE_TYPE = {
  noAssignments: 'noAssignments',
  noActivity: 'noActivity',
  noQuestionsTagged: 'noQuestionsTagged',
};
export const GET_COURSE_ABSTRACT = 'GET_COURSE_ABSTRACT';
export const GET_WIDGET_REPORT = 'GET_WIDGET_REPORT';
export const GET_QQ_OVERVIEW_REPORT = 'GET_QQ_OVERVIEW_REPORT';
export const GET_STUDENT_OVERVIEW_REPORT = 'GET_STUDENT_OVERVIEW_REPORT';
export const ADD_STUDENT_OVERVIEW_REPORT = 'ADD_STUDENT_OVERVIEW_REPORT';
export const GET_SKILLS_OVERVIEW_REPORT = 'GET_SKILLS_OVERVIEW_REPORT';
export const GET_REVISION_PLAN_WIDGET = 'GET_REVISION_PLAN_WIDGET';
export const GET_QQ_STUDENT_UNIT_REPORT = 'GET_QQ_STUDENT_UNITS_REPORT';
export const GET_QQ_STUDENT_SUBUNIT_REPORT = 'GET_QQ_STUDENT_SUBUNITS_REPORT';
export const SET_STUDENT_ACTIVE_UNIT = 'SET_STUDENT_ACTIVE_UNIT';
export const SET_STUDENT_ACTIVE_SUBUNIT = 'SET_STUDENT_ACTIVE_SUBUNIT';
export const ADD_STUDENT_UNIT_REPORT = 'ADD_STUDENT_UNIT_REPORT';
export const ADD_STUDENT_SUBUNIT_REPORT = 'ADD_STUDENT_SUBUNIT_REPORT';
export const SET_REPORTS_AUTH = 'SET_REPORTS_AUTH';
export const SET_REPORTS_LOADING = 'SET_REPORTS_LOADING';
export const SET_REPORTS_LOADED = 'SET_REPORTS_LOADED';
export const CLEAR_REPORTS = 'CLEAR_REPORTS';
export const SET_REPORTS_COMING_SOON = 'SET_REPORTS_COMING_SOON';
export const SET_INDIVIDUAL_REPORT_LOADING = 'SET_INDIVIDUAL_REPORT_LOADING';
export const GET_UNIT_LIST = 'GET_UNIT_LIST';
export const GET_SUBUNIT_LIST = 'GET_SUBUNIT_LIST';
export const SET_UNIT_LIST_LOADING = 'SET_UNIT_LIST_LOADING';
export const SET_SUBUNIT_LIST_LOADING = 'SET_SUBUNIT_LIST_LOADING';
export const GET_UNIT_REPORT = 'GET_UNIT_REPORT';
export const GET_SUBUNIT_REPORT = 'GET_SUBUNIT_REPORT';
export const ADD_UNIT_REPORT = 'ADD_UNIT_REPORT';
export const ADD_SUBUNIT_REPORT = 'ADD_SUBUNIT_REPORT';
export const SET_ACTIVE_UNIT = 'SET_ACTIVE_UNIT';
export const SET_ACTIVE_SUBUNIT = 'SET_ACTIVE_SUBUNIT';
export const FETCHED_SKILLS_FEEDBACK_SUMMARY_REPORT =
  'FETCHED_SKILLS_FEEDBACK_SUMMARY_REPORT';
export const FETCHING_SKILLS_FEEDBACK_SUMMARY_REPORT =
  'FETCHING_SKILLS_FEEDBACK_SUMMARY_REPORT';
export const UPDATE_ACTIVE_FEEDBACK_SKILLS_REPORT =
  'UPDATE_ACTIVE_FEEDBACK_SKILLS_REPORT';
export const FAILED_FETCH_SKILLS_FEEDBACK_SUMMARY_REPORT =
  'FAILED_FETCH_SKILLS_FEEDBACK_SUMMARY_REPORT';
export const FETCHING_REFLECTIONS_SUMMARY_TRENDS_DATA =
  'FETCHING_REFLECTIONS_SUMMARY_TRENDS_DATA';
export const FETCHED_REFLECTIONS_SUMMARY_TRENDS_DATA =
  'FETCHED_REFLECTIONS_SUMMARY_TRENDS_DATA';
export const FAILED_FETCH_REFLECTIONS_SUMMARY_TRENDS_DATA =
  'FAILED_FETCH_REFLECTIONS_SUMMARY_TRENDS_DATA';
export const UPDATE_ACTIVE_DRAFT_REFLECTIONS_SUMMARY =
  'UPDATE_ACTIVE_DRAFT_REFLECTIONS_SUMMARY';
export const FETCHING_NOT_REVIEWED_FEEDBACK_SUMMARY_REPORT =
  'FETCHING_NOT_REVIEWED_FEEDBACK_SUMMARY_REPORT';
export const FETCHED_NOT_REVIEWED_FEEDBACK_SUMMARY_REPORT =
  'FETCHED_NOT_REVIEWED_FEEDBACK_SUMMARY_REPORT';
export const FAILED_FETCH_NOT_REVIEWED_FEEDBACK_SUMMARY_REPORT =
  'FAILED_FETCH_NOT_REVIEWED_FEEDBACK_SUMMARY_REPORT';
export const FETCHING_REVISION_PLANS_NOT_STARTED =
  'FETCHING_REVISION_PLANS_NOT_STARTED';
export const FETCHED_REVISION_PLANS_NOT_STARTED =
  'FETCHED_REVISION_PLANS_NOT_STARTED';
export const FAILED_FETCH_REVISION_PLANS_NOT_STARTED =
  'FAILED_FETCH_REVISION_PLANS_NOT_STARTED';
export const SET_NAVIGATION_BAR = 'SET_NAVIGATION_BAR';
export const SET_NAVIGATION_NODES_STATE = 'SET_NAVIGATION_NODES_STATE';
export const GET_SKILLS_NAVIGATION = 'GET_SKILLS_NAVIGATION';
export const SET_SKILLS_NAVIGATION_LOADING = 'SET_SKILLS_NAVIGATION_LOADING';
export const TOGGLE_INSIGHT_LO_DETAILS_MODAL =
  'TOGGLE_INSIGHT_LO_DETAILS_MODAL';
export const TOGGLE_INSIGHT_EXTERNAL_LO_MODAL =
  'TOGGLE_INSIGHT_EXTERNAL_LO_MODAL';
export const TOGGLE_INSIGHT_ASSIGNMENT_DETAILS_MODAL =
  'TOGGLE_INSIGHT_ASSIGNMENT_DETAILS_MODAL';
export const GET_DASHBOARD = 'GET_DASHBOARD';
export const GET_DASHBOARD_REQUEST = 'GET_DASHBOARD_REQUEST';
export const GET_DASHBOARD_RESPONSE = 'GET_DASHBOARD_RESPONSE';
export const GET_SRL_REQUEST = 'GET_SRL_REQUEST';
export const GET_SRL_RESPONSE = 'GET_SRL_RESPONSE';
export const GET_SRL_RESULTS_REQUEST = 'GET_SRL_RESULTS_REQUEST';
export const GET_SRL_RESULTS_RESPONSE = 'GET_SRL_RESULTS_RESPONSE';
export const GET_SRL_RESULT_CARD_REQUEST = 'GET_SRL_RESULT_CARD_REQUEST';
export const GET_SRL_RESULT_CARD_RESPONSE = 'GET_SRL_RESULT_CARD_RESPONSE';
export const ADD_WIDGET_TO_DASHBOARD = 'ADD_WIDGET_TO_DASHBOARD';
export const DELETE_DASHBOARD_WIDGET = 'DELETE_DASHBOARD_WIDGET';
export const UPDATE_WIDGETS = 'UPDATE_WIDGETS';
export const TOGGLE_WIDGET_DETAIL_MODAL = 'TOGGLE_WIDGET_DETAIL_MODAL';
export const CLEAR_INSIGHT_MODALS = 'CLEAR_INSIGHT_MODALS';
export const CONTAINER_WIDTH_CHANGE = 'CONTAINER_WIDTH_CHANGE';
export const GET_ASSIGNMENTS = 'GET_ASSIGNMENTS';
export const SET_INSIGHTS_SELECTED_ASSIGNMENT =
  'SET_INSIGHTS_SELECTED_ASSIGNMENT';
export const UPDATE_SRL_WIDGETS_HEIGHT = 'UPDATE_SRL_WIDGETS_HEIGHT';
export const SET_INSIGHTS_TAB = 'SET_INSIGHTS_TAB';

export const REPORT_TYPES = {
  skills: 'skills',
  skillsWidget: 'skillsWidget',
  qqWidget: 'qqWidget',
  revisionPlanWidget: 'revisionPlanWidget',
  subunit: 'subunit',
  unit: 'unit',
  unitOverview: 'unitOverview',
  reflections: 'reflections',
  skillsFeedbackSummary: 'skills-feedback-summary',
  skillsNotReviewedFeedbackSummary: 'skills-not-reviewed-feedback-summary',
  studentUnit: 'student-unit',
  studentSubunit: 'student-subunit',
  studentOverview: 'student-overview',
  revisionPlansNotStarted: 'revision-plans-not-started',
  overview: 'overview',
};

export const REPORT_TYPE_NAMES = {
  [REPORT_TYPES.skills]: 'Skills Overview',
  [REPORT_TYPES.skillsWidget]: 'Skills Widget',
  [REPORT_TYPES.qqWidget]: 'QQ Widget',
  [REPORT_TYPES.revisionPlanWidget]: 'Skills Student Revision Plan Widget',
  [REPORT_TYPES.subunit]: 'QQ Subunit',
  [REPORT_TYPES.unit]: 'QQ Unit',
  [REPORT_TYPES.unitOverview]: 'QQ Unit Overview',
  [REPORT_TYPES.reflections]: 'Skills Reflections',
  [REPORT_TYPES.skillsFeedbackSummary]: 'Skills Feedback Summary',
  [REPORT_TYPES.skillsNotReviewedFeedbackSummary]:
    'Skills Not Reviewed Feedback Summary',
  [REPORT_TYPES.studentUnit]: 'QQ Student Unit',
  [REPORT_TYPES.studentSubunit]: 'QQ Student Subunit',
  [REPORT_TYPES.studentOverview]: 'QQ Student Overview',
  [REPORT_TYPES.revisionPlansNotStarted]: 'Skills Revision Plans Not Started',
};

export const REPORT_KEYS = {
  unitOverview: 'unitOverview',
  overviewWidget: 'overviewWidget',
  studentOverview: 'studentOverview',
  unitReport: 'unitReport',
  subunitReport: 'subunitReport',
  skillsOverview: 'skillsOverview',
  revisionPlanWidget: 'revisionPlanWidget',
  skillsOverviewWidget: 'skillsOverviewWidget',
  studentUnitReport: 'studentUnitReport',
  studentSubunitReport: 'studentSubunitReport',
};

export const REPORT_TYPE_INSIGHTS_LO = 'reportTypeInsightsLo';
export const REPORT_TYPE_INSIGHTS_ASSIGNMENT = 'reportTypeInsightsAssignment';
export const REPORT_TYPE_INSIGHTS_EXTERNAL_LO = 'reportTypeInsightsExternalLO';
export const REPORT_TYPE_LOGIN_INSIGHTS = 'reportTypeLoginInsights';
export const REPORT_TYPE_ASSIGNMENT_SCORE = 'reportTypeAssignmentScore';
export const REPORT_TYPE_TIME_SCORE = 'reportTypeTimeScore';
export const REPORT_TYPE_TIME_ATTEMPTS = 'reportTypeTimeAttempts';
export const REPORT_TYPE_COMPLETED_ASSIGNMENT = 'reportCompletedAssignment';

// Writing tool pages
export const WRITING_TYPE = {
  REVISION_PLAN: 'revisionplan',
  REVIEW_FEEDBACK: 'reviewfeedback',
};

// COURSE TABS
export const COURSE_TABS = {
  ASSIGNMENTS: { id: 'assignments', name: 'ASSIGNMENTS' },
  PEOPLE: { id: 'people', name: 'PEOPLE' },
};

// UI Related values
export const CSS_VALUES = {
  ACTIVITY_HEADER_HEIGHT: 56, // linked to: --activity_header_height css variable
  TABLE_OF_CONTENT_MIN_WIDTH: 360,
  LIBRARY_LIST_ITEM_HEIGHT: 55, // linked to: --library_list_item_height css variable
  FOLDER_TAB_LEVEL_PADDING: 22,
};

/**
 * The available brands.
 * @typedef {typeof BRANDS[keyof BRANDS]} Brands
 */
export const BRANDS = Object.freeze({
  HIGHER_ED: 'he',
  HIGH_SCHOOL: 'hs',
});
